<template>
  <div>
    <span style="font-size: 12px;color:gray ">输入您的症状，系统将为你推荐相关的西药和中成药。</span>
    <el-column :span="2">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix" style="border: none">
          <i class="el-icon-card-header-red"></i>
          <span>输入症状关键词</span>
        </div>
        <div>
          <el-form ref="form" :model="textForm" size="mini">
            <el-form-item label="输入症状：">
              <el-input
                  type="textarea"
                  :rows="5"
                  placeholder="请输入内容"
                  v-model="textForm.content">
              </el-input>
            </el-form-item>
            <el-form-item size="large">
              <el-button type="primary"
                         style="margin-left: 20px;background-color: rgb(46, 205, 129); border-color: rgb(46, 205, 129); color: white;"
                         @click="onSubmit">分析
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </el-column>

    <el-column :span="12">
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix" style="border: none">
          <i class="el-icon-card-header-red"></i>
          <span>药物推荐</span>
        </div>
        <div>
          <b-card-text>西药推荐</b-card-text>
          <el-col
              v-for="item in  this.cure_result[1].west_med" style="margin-top: 0px"
              :key="item.diagnose"
              effect="dark">
            <el-row v-for="item2 in  item.drugList" :key="item2.drugNameGer" style="float:left">
              <el-tag>{{ item2.drugNameGer }}</el-tag>
            </el-row>
          </el-col>
          <b-card-text style="margin-top: 20px">中成药推荐</b-card-text>
          <el-col
              v-for="item in  this.cure_result[0].mid_med" style="margin-top: 0px"
              :key="item.diagnose"
              effect="dark">
            <!--              疾病：{{ item.diagnose }}-->
            <el-row v-for="item2 in  item.drugList" :key="item2.drugNameGer" style="float:left">
              <el-tag>{{ item2.drugNameGer }}</el-tag>
            </el-row>
          </el-col>
        </div>
      </el-card>
    </el-column>

  </div>
</template>

<script>
export default {
  name: "DiagToDrugAndAcupoint",
  mounted() {
    this.onSubmit()
  },
  data() {
    return {
      textForm: {
        content: '小儿功能性消化不良 糖尿病 冠心病办',
      },
      result_disease: null,
      result_med: null,
      result_med_cat: null,
      result_med_exam: null,
      result_oper: null,
      result_symp: null,
      cure_result: null
    };
  },
  methods: {
    onSubmit() {
      console.log('submit!');
      let params = {"diagnose": this.textForm.content, "threshold": 2}
      this.$http.post(process.env.VUE_APP_API_HOST_FOR_CHUNBO + "/get_diagnose_to_drug", params,
          {"content-type": "application/json"}).then((res) => {
        this.cure_result = res.data.data
      })
    }
  }
}
</script>

<style scoped>
.el-tag {
  margin-left: 10px
}

</style>
